/**
 * Inner layers for a `.cta` button: a fill that rises from the bottom edge
 * with a curved lip, and a label that rolls up to a copy of itself.
 */
export function RollLabel({ children }: { children: string }) {
  return (
    <>
      <span className="cta-fill" aria-hidden="true">
        <span />
      </span>
      <span className="cta-label">
        <span data-text={children}>{children}</span>
      </span>
    </>
  );
}
